"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AppMenu {
}
exports.default = AppMenu;
//# sourceMappingURL=AppMenu.js.map